import React from 'react';
import PropTypes from 'prop-types';
import { IS_EDITOR_MODE } from 'config/envVariable';
import { neutral900, functional, form500 } from '@fever/ui';
import MuiThemeProvider, { formTheme, formThemeClient } from 'common/style/MuiThemeProvider';

export default function ProviderTheme({ children, config = {} }) {
    const theme = IS_EDITOR_MODE
        ? formTheme
        : formThemeClient({
              primaryColor: functional,
              secondaryColor: form500,
              textColor: neutral900,
              fontFamily: config.fontFamily
          });

    return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}

ProviderTheme.propTypes = {
    children: PropTypes.node
};
